import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axiosInstance from "../AxiosInstance";

export interface ProductOption {
    productId: number;
    skuNumber: string;
    skuDescription: string;
}

export interface ProductDropdownProps {
    onProductsSelected: (productIds: number[]) => void;
    productErrorText?: string;
    setProducts: (products: ProductOption[]) => void;
    excludedProductIds?: number[];
}

const ProductDropdown: React.FC<ProductDropdownProps> = ({
    onProductsSelected,
    productErrorText = "",
    setProducts,
    excludedProductIds = []
}) => {
    const [products, setProductsState] = useState<ProductOption[]>([]);
    const [selectedProducts, setSelectedProducts] = useState<ProductOption[]>([]);
    const [helperText, setHelperText] = useState("");

    useEffect(() => {
        fetchProducts();
    }, []);

    useEffect(() => {
        setHelperText(productErrorText);
    }, [productErrorText]);

    const fetchProducts = async () => {
        try {
            const response = await axiosInstance.get<ProductOption[]>("/products");
            const allProducts = response.data;

            const filteredProducts = allProducts.filter(
                (product) => !excludedProductIds.includes(product.productId)
            );

            setProductsState(filteredProducts);
            setProducts(filteredProducts);
        } catch (error) {
            console.log(error);
        }
    };

    const handleProductChange = (
        _event: React.SyntheticEvent,
        values: ProductOption[]
    ) => {
        setSelectedProducts(values);
        const selectedProductIds = values.map((value) => value.productId);
        onProductsSelected(selectedProductIds);
    };

    return (
        <div>
            <Autocomplete<ProductOption, true>
                multiple
                id="tags-outlined"
                disableCloseOnSelect
                options={products}
                getOptionLabel={(product) =>
                    `${product.skuDescription} - ${product.skuNumber}`
                }
                isOptionEqualToValue={(option, value) =>
                    option.productId === value.productId
                }
                sx={{ width: 280 }}
                value={selectedProducts}
                onChange={handleProductChange}
                filterSelectedOptions
                renderOption={(props, option) => (
                    <li {...props} key={option.productId}>
                        {option.skuDescription} - {option.skuNumber}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="SKU"
                        error={Boolean(helperText)}
                        helperText={helperText}
                    />
                )}
            />
        </div>
    );
};

export default ProductDropdown;
